import type {
  EnterpriseProgramForProgramSwitcher as EnterpriseProgram,
  ThirdPartyOrganizationForProgramSwitcher as ThirdPartyOrganization,
} from 'bundles/composable-page-header/components/program-switcher/types';
import { sortEnterpriseProgramsByLaunchedAt } from 'bundles/composable-page-header/utils/sortByLaunchedAt';

export type OrganizationWithPrograms = ThirdPartyOrganization & {
  programs: Array<EnterpriseProgram>;
};

// group programs by third party organization
export const groupByOrganization = (programs: Array<EnterpriseProgram>): Array<OrganizationWithPrograms> => {
  const organizations = programs.reduce((orgsWithPrograms, program) => {
    const { naptimeThirdPartyOrganization } = program;

    if (!naptimeThirdPartyOrganization) {
      return orgsWithPrograms;
    }

    let newOrgs = orgsWithPrograms;
    const organization = newOrgs.find((org) => org.id === naptimeThirdPartyOrganization.id);
    if (organization) {
      organization.programs.push(program);
    } else {
      newOrgs = [...newOrgs, { ...naptimeThirdPartyOrganization, programs: [program] }];
    }
    return newOrgs;
  }, [] as OrganizationWithPrograms[]);
  return organizations;
};

const getByOrganizations = (programs: EnterpriseProgram[]) => {
  const sortedPrograms = sortEnterpriseProgramsByLaunchedAt(programs);

  return sortedPrograms.length > 0 ? groupByOrganization(sortedPrograms) : [];
};

export default getByOrganizations;
